import { render, staticRenderFns } from "./AppliancesComponent.vue?vue&type=template&id=3db74352&"
import script from "./AppliancesComponent.vue?vue&type=script&lang=js&"
export * from "./AppliancesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports